<template>
    <!-- 暂无权限 -->
  <the-no-authority v-if="!authority"></the-no-authority>
  <div class="page_box" v-else>
    <div class="page_table_box"  style="height:calc(100% - 10px)">
      <div class="school_table_box">
      <el-table :data="tableData" 
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              listParams.pageSize * (listParams.pageNum - 1) + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="issueTitle"
          label="任务标题"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="下发时间"
          show-overflow-tooltip
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            {{ $Common.dateFormatDateTwo(scope.row.releaseTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="rowData">
            <el-link
              type="primary"
              @click="checkDetail(rowData.row.id)"
              :underline="false"
              >详情</el-link
            >
            <el-divider direction="vertical"></el-divider>
            <el-dropdown>
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="dropdown_item_box"
                  ><el-link
                    class="link_box"
                    type="primary"
                    @click="uploadTask(rowData.row.id)"
                    :underline="false"
                    >上报任务</el-link
                  ></el-dropdown-item
                >
                <el-dropdown-item class="dropdown_item_box"
                  ><el-link
                    class="link_box"
                    type="primary"
                    @click="uploadListClick(rowData.row.id)"
                    :underline="false"
                    >上报记录</el-link
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="listParams.pageNum"
          :page-size="listParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
      <el-dialog
        title="任务下发详情"
        :visible.sync="detailShow"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="50%"
      >
        <el-form :model="detailInfo" label-width="100px">
          <el-form-item label="任务标题:">
            <span>{{ detailInfo.issueTitle }}</span>
          </el-form-item>
          <el-form-item label="任务内容:">
            <span>{{ detailInfo.issueTaskRequirements }}</span>
          </el-form-item>
          <el-form-item label="任务附件:">
            <el-link
              v-show="detailInfo.fileList.length > 0"
              style="margin-left:20px;width: 80%;display: flex;justify-content:left "
              type="primary"
              v-for="(item, index) in detailInfo.fileList"
              :key="index"
              @click="$Common.fileDownloads(item.fileUrl)"
              >{{ item.fileUrl.split("/").pop() }}<br
            /></el-link>
            <span v-show="detailInfo.fileList.length == 0"> 暂无附件</span>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        title="上报任务"
        :visible.sync="taskUploadShow"
        direction="ltr"
        :wrapperClosable="false"
        :close-on-press-escape="false"
        :before-close="drawerClose"
      >
        <el-form
          :model="taskUploadFrom"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
          style="overflow-y: scroll"
          class="demo-ruleForm"
        >
          <el-form-item label="上报内容:" prop="fillinTheContent">
            <el-input
              v-model.trim="taskUploadFrom.fillinTheContent"
              size="small"
              style="width:80%"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 4 }"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="上报任务附件:">
            <el-upload
              ref="uploadRef"
                :action="this.$store.state.config.baseURL +'/file/upload'"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success='handleSuccess'
                accept=".xls,.xlsx,.doc,.docx"
                :headers="headers"
                :file-list="fileList">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
          </el-form-item>
        </el-form>
        <span class="dialog-footer" slot="footer">
          <el-button type="primary" size="mini" @click="sendClick('ruleForm')"
              >提交</el-button
            >
          <el-button @click="backClick()" size="mini">返回</el-button>
        </span>
        <!-- <div class="demo-drawer__footer insert_data_button_box">
          <label class="col-sm-2 control-label"></label>
          <div class="col-sm-10">
            <el-button type="primary" size="mini" @click="sendClick('ruleForm')"
              >提交</el-button
            >
            <el-button @click="backClick()" size="mini">返回</el-button>
          </div>
        </div> -->
      </el-dialog>
      <el-dialog
        title="上报记录"
        :visible.sync="uploadListShow"
        direction="ltr"
        :modal="false"
        size="40%"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <el-table
          :data="uploadListData"
          border
          height="800px"
          style="width:90%;margin-left:5%"
          size="mini"
        >
          <el-table-column
            label="上报内容"
            prop="fillInTheContent"
            show-overflow-tooltip
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="上报附件"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                v-show="scope.row.multipleAttachments != ''"
                icon="el-icon-document"
                v-for="(item, index) in scope.row.multipleAttachments.split(
                  '#'
                )"
                :key="index"
                >{{ item.substring(item.length - 9) }}</el-link
              >
              <span v-show="scope.row.multipleAttachments == ''">暂无附件</span>
            </template>
          </el-table-column>
          <el-table-column
            label="上报时间"
            width="150"
            prop="reportingTime"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ $Common.dateFormatDate(scope.row.reportingTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                plain
                icon="el-icon-brush"
                @click="rowRepeal(scope.row.id)"
                >撤销</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right;margin:10px">
          <el-pagination
            background
            @current-change="uploadCurrentChagne"
            :current-page="uploadListParams.pageNum"
            :page-size="uploadListParams.pageSize"
            layout="total, prev, pager, next"
            :total="uploadListCount"
          >
          </el-pagination>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import theNoAuthority from "@/components/theNoAuthority";
const CryptoJS = require("crypto-js"); //引用加密源码js

export default {
  name: "taskIssue",
  components: {
    theNoAuthority
  },
  data() {
    return {
      // 有无权限
      authority: true,
      tableData: [],
      params: {
        id: "",
        type:2,
        currencyId: ""
      },
      listParams: {
        receivingOrganizationId: JSON.parse(sessionStorage.getItem("userInfo"))
          .schoolId,
        pageSize: 20,
        type:2,
        pageNum: 1,
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId
      },
      total: 0,
      detailShow: false,
      detailInfo: {
        fileList: []
      },
      taskUploadFrom: {
        schoolId: JSON.parse(sessionStorage.getItem("userInfo")).schoolId, //所属学校id
        issuedId: "", //任务id
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId, //当前用户id
        fillinTheContent: "", //上报内容
        multipleAttachments: "", //上报附件
        fileList: []
      },
      taskUploadShow: false,
      rules: {
        fillinTheContent: {
          required: true,
          message: " ",
          trigger: "blur"
        }
      },
      uploadListParams: {
        issuedId: "",
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId, //当前用户id
        pageSize: 20,
        pageNum: 1
      },
      uploadListShow: false, //上报记录
      uploadListData: [], //上报记录数组
      uploadListCount: 0,
      fileList:[]
    };
  },
  computed:{
      headers(){
        let headers = {}
        // sign 验证
        let appKey = "shuangan20200417";
        let param = null;
        let paramKey = [];
        let sign = "";
        if (typeof param == "object" && !Array.isArray(param)) {
          if (param != null && param != undefined && param != "") {
            var arr = [];
            param = Object.assign({}, param);
            for (var i in param) {
              arr.push(i);
            }
            paramKey = arr.sort();
          }
          if (paramKey.length > 0) {
            sign = "";
            let paramString = JSON.stringify(param);
            paramString = paramString.replace(/\s+/g, "").replace("s*|\t|\r|\n/g", "");
            sign = appKey + paramString;
          }
          if ((paramKey.length > 0 )) {
            sign = "";
            paramKey.forEach((element) => {
              if (element != "file") {
                sign = sign + param[element].toString();
              }
            });
            sign = sign + appKey;
          }
        }
        if (Array.isArray(param)) {
          sign = appKey + JSON.stringify(param);
        }
        if (!param) {
          sign = sign + appKey;
        }
        var localTime2 = parseInt(Date.parse(new Date()) / 1000);
        var localTime1 = sessionStorage.getItem('localTime1');
        var serverTime = sessionStorage.getItem('serverTime');
        var timeStamp = Number(localTime2) - Number(localTime1) + Number(serverTime);
        sign = sign + timeStamp;
        sign = CryptoJS.MD5(sign);

        var userInfo = this.$store.getters.getUserInfo;
        if (userInfo != false) {
          headers.token = userInfo.token;
          headers.timestamp = timeStamp;
          headers.sign = sign;
          headers.userId = userInfo.userId;
        }
        return headers;
      },
    },
  mounted() {
    this.getEducationList();
  },
  methods: {
    async getEducationList() {
      let res = await this.$Http.getEducationList(this.listParams);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          message: res.messsage || "上级教育局的下发任务查询失败",
          type: "error"
        });
      }
    },
    handleCurrentChange(val) {
      this.listParams.pageNum = val;
      this.getEducationList();
    },
    checkDetail(id) {
      if (id) {
        this.detailShow = true;
        this.params.id = id;
        this.params.currencyId = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).schoolId;
        this.getDetailInfo();
      }
    },
    async getDetailInfo() {
      let res = await this.$Http.getDetailInfo(
        Object.assign({}, this.params),
        true
      );
      if (res.code == 200) {
        let data = res.data[0] || [];
        this.detailInfo = data;
        if (data.sendAttachments == "") {
          this.detailInfo.fileList = [];
        } else {
          this.detailInfo.fileList = data.sendAttachments
            .split("#")
            .map((item) => {
              return {
                fileUrl: item
              };
            });
        }
      } else if (res.code == 101) {
        this.detailInfo = {
          fileList: []
        };
      } else {
        this.detailInfo = {
          fileList: []
        };
        this.$message({
          message: res.messsage || "详情获取失败",
          type: "error"
        });
      }
    },
    refreshData() {
      this.$message({
        showClose: true,
        message: "刷新成功",
        type: "success"
      });
      this.getEducationList();
    },
    // 提交
    sendClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let list = this.fileList.map((item) => {
            return item.url;
          });
          this.taskUploadFrom.multipleAttachments = list.join("#");
          delete this.taskUploadFrom.fileList;
          this.addInfo();
        } else {
          return false;
        }
      });
    },
    async addInfo() {
      let res = await this.$Http.reportingTasks(
        Object.assign({}, this.taskUploadFrom)
      );
      if (res.code == 200) {
        this.$message({
          message: "任务上报成功",
          type: "success"
        });
        this.taskUploadShow = false;
        this.refershData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage || "任务上报失败",
          type: "error"
        });
      }
    },
    // 返回按钮
    backClick() {
      this.taskUploadShow = false;
      this.refershData();
    },
    uploadTask(id) {
      if (id) {
        this.taskUploadFrom.issuedId = id;
        this.taskUploadShow = true;
      }
    },
    drawerClose() {
      this.taskUploadShow = false;
      this.refershData();
    },
    refershData() {
      this.taskUploadFrom = {
        schoolId: JSON.parse(sessionStorage.getItem("userInfo")).schoolId, //所属学校id
        issuedId: "", //任务id
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId, //当前用户id
        fillinTheContent: "", //上报内容
        multipleAttachments: "", //上报附件
        fileList: []
      };
      this.fileList = []
    },
    uploadListClick(id) {
      if (id) {
        this.uploadListParams.issuedId = id;
        this.getUploadList();
      }
    },
    async getUploadList() {
      let res = await this.$Http.getReportedList(
        Object.assign({}, this.uploadListParams)
      );
      if (res.code == 200) {
        this.uploadListData = res.data.list || [];
        this.uploadListCount = res.data.total || 0;
        this.uploadListShow = true;
      } else if (res.code == 101) {
        this.uploadListData = [];
        this.uploadListCount = 0;
        this.$message({
          message: "暂无数据",
          type: "warning",
          duration: 1000
        });
      } else {
        this.uploadListData = [];
        this.uploadListCount = 0;
        this.$message({
          message: res.messsage || "上报记录获取失败",
          type: "error"
        });
      }
    },
    // 上报记录分页
    uploadCurrentChagne(val) {
      this.uploadListParams.pageNum = val;
      this.getUploadList();
    },
    // 列表撤销
    rowRepeal(id) {
      if (id) {
        this.$confirm("此操作将永久撤销该任务, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.repealTask({ id: id });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消撤销"
            });
          });
      }
    },
    async repealTask(req) {
      let res = await this.$Http.revokeMyTask(Object.assign({}, req), true);
      if (res.code == 200) {
        this.$message({
          message: "任务上报撤销成功",
          type: "success"
        });
        this.getUploadList();
      } else {
        this.$message({
          message: res.messsage || "任务上报撤销失败",
          type: "error"
        });
      }
    },
    // 上传成功
    handleSuccess(response, file, fileList){
      var newFileInfo = {}
      for (var testData in response.data) {
        newFileInfo = {
          name: testData,
          url: response.data[testData]
        };
      }
      this.fileList.push(newFileInfo)
    },
    handleRemove(file, fileList){
      this.fileList = this.$refs.uploadRef.uploadFiles || []
    },
    // 点击上传列表中的文件
    handlePreview(file){
      let url = file.response.data
      var newFileInfo = {}
      for (var testData in url) {
        newFileInfo = {
          fileName: testData,
          fileUrl: url[testData]
        };
      }
      this.$Common.filePreview(newFileInfo.fileUrl)
    }
  }
};
</script>
<style scoped lang="scss"></style>
